import { join } from 'light-component';
import { Icons, Box } from '@common';
import * as Base from '@base';
import styles from './style.module.less';
import type { ReactElement } from 'react';
import type { ThumbnailProps } from './types';

export function Thumbnail(props: ThumbnailProps): ReactElement {
  if (props.toolTipContent != null) {
    return (<Base.Tooltip placement='right' title={props.toolTipContent}>
      <Box className={join(styles.control, props.className)}>
        <Icons name={props.icon} className={styles.icon} />
        <Box component='span' className={styles.text}>{props.title}</Box>
      </Box>
    </Base.Tooltip>);
  }
  return (
    <Box className={join(styles.control, props.className)}>
      <Icons name={props.icon} className={styles.icon} />
      <Box component='span' className={styles.text}>{props.title}</Box>
    </Box>
  );
}
